export default {
  account: {
    academy_capitalized: "Học viện",
    change_photo: "Thay đổi ảnh",
    currency: "Tiền tệ",
    currency_description: "Tiền tệ cho học phí sinh viên và lương giảng viên",
    email_capitalized: "Email",
    first_name_capitalized: "Tên đầu tiên",
    language: "Ngôn ngữ",
    language_settings: "Cài đặt ngôn ngữ",
    last_name_capitalized: "Họ",
    personal_information: "Thông tin cá nhân",
    plan_usage: "Kế hoạch và Sử dụng",
    policy: "Chính sách",
    policy_setting_before: "Giờ trước",
    policy_setting_cancel: "Hủy bỏ",
    policy_setting_cancel_subtitle: "Cài đặt số giờ trước khi có thể yêu cầu hủy bỏ các buổi học.",
    policy_subtitle: "Cài đặt số giờ trước khi có thể yêu cầu lên lịch lại các buổi học.",
    profile: "Hồ sơ",
    reschedule: "Sắp xếp lại",
    subscription: "Đăng ký",
    subscription_info_contact: "{'Vui lòng liên hệ yan@getfunclass.com để quản lý hoặc hủy đăng ký của bạn. Cảm ơn!'}",
    subtitle: "Bạn có thể quản lý cài đặt tài khoản của mình ở đây.",
    title: "Cài đặt tài khoản"
  },
  auth: {
    agency_name: "Trung tâm học phí",
    agree_to: "Tôi đồng ý với",
    alreadyhasaccount: "Đã có tài khoản?",
    confirmPassword: "Xác nhận mật khẩu",
    createaccount: "Tạo tài khoản",
    email: "Email",
    email_enter: "Nhập email của bạn",
    email_send: "Gửi email",
    firstname: "Tên đầu tiên",
    firstname_student: "Tên đầu tiên của sinh viên",
    forgotpassword: "Quên mật khẩu?",
    hasaccount: "Chưa có tài khoản?",
    lastname: "Họ",
    login: "Đăng nhập",
    loginbutton: "Đăng nhập",
    logout: "Đăng xuất",
    no_active_account: "Không tìm thấy tài khoản hoạt động với thông tin đăng nhập đã cho",
    password: "Mật khẩu",
    passwordreset: "Đặt lại mật khẩu của bạn",
    passwordresetbutton: "Đặt lại mật khẩu",
    required: {
      agency_name: "Tên trung tâm học phí là bắt buộc",
      email: "Email là bắt buộc",
      email_exists: "Tài khoản với email này đã tồn tại",
      first_name: "Tên đầu tiên là bắt buộc",
      invalid_email: "Email không hợp lệ",
      last_name: "Họ là bắt buộc",
      password: "Mật khẩu là bắt buộc",
      password_length: "Mật khẩu phải dài ít nhất 8 ký tự",
      password_requirement: "Mật khẩu phải chứa ít nhất một chữ cái viết hoa, một chữ cái viết thường, một chữ số và một ký tự đặc biệt ({'@'} $ ! % * ? & #)."
    },
    reset: "Đặt lại",
    signup: "Đăng ký",
    signup_subtitle: "Nhập thông tin xác thực của bạn để tạo tài khoản trên Funclass.",
    terms: "Điều khoản và Điều kiện"
  },
  button: {
    archive: "Lưu trữ",
    copy: "Sao chép",
    delete: "Xóa",
    edit: "Chỉnh sửa",
    invite: "Mời",
    save: "Lưu",
    submit: "Gửi",
    unarchive: "Bỏ lưu trữ"
  },
  course: {
    chinese_students: "Lớp học này có học sinh ở Trung Quốc",
    class_name: "Tên lớp học",
    class_name_placeholder: "Nhập tên lớp học của bạn vào đây",
    class_settings: {
      account_type: "Loại tài khoản",
      account_type_warning_non_gamified: "Học sinh sẽ không có thú cưng và sẽ không thu thập XP/HP.",
      account_type_warning_setup: "Loại trò chơi chỉ có thể được đặt một lần khi tạo lớp học.",
      enable_breakout_room: "Bật phòng nhóm (tắt tự động kết nối âm thanh)",
      gamified: "Có trò chơi hóa",
      non_gamified: "Không trò chơi hóa",
      recording_exclude_webcam: "Bản ghi không bao gồm webcam của học sinh",
      title: "Cài đặt lớp học"
    },
    create: "Thêm lớp",
    delete: "xóa",
    delete_confirmation: "Xác nhận xóa",
    delete_message: "Bạn có chắc chắn muốn xóa lớp học này không?",
    delete_student: "Bạn có chắc chắn muốn xóa học sinh này khỏi lớp không?",
    duration: "Thời lượng",
    duration_time_unit: "phút",
    edit: "Chỉnh sửa lớp",
    filters: {
      active: "Lớp đang hoạt động",
      all: "Tất cả các lớp",
      archived: "Lớp đã lưu trữ"
    },
    join: "Tham gia lớp học",
    link_valid_for: "Liên kết này có giá trị trong {n} ngày.",
    name_too_short: "Tên khóa học phải có ít nhất 2 ký tự",
    no_content: {
      filtered: {
        subtitle: "Hãy thử thay đổi bộ lọc.",
        title: "Không có lớp nào ở đây"
      },
      general: {
        teacher_subtitle: "Nhấn nút “Thêm lớp” để bắt đầu!",
        teacher_subtitle_agency: "Chưa có khóa học nào được giao. Vui lòng chờ học viện giao cho bạn một khóa học.",
        title: "Chưa tạo lớp nào"
      }
    },
    notify: {
      archive_course_error: "Lỗi khi lưu trữ khóa học",
      archive_course_success: "Lớp {courseName} đã được lưu trữ thành công!",
      copy_link_error: "Lỗi khi sao chép liên kết",
      copy_link_success: "Đã sao chép!",
      delete_course_error: "Lỗi khi xóa khóa học",
      edit_course_error: "Lỗi khi chỉnh sửa khóa học",
      required_fields: "Vui lòng điền vào các trường bắt buộc",
      start_meeting_error: "Lỗi khi bắt đầu buổi học. Vui lòng thử lại.",
      unarchive_course_error: "Lỗi khi khôi phục khóa học",
      unarchive_course_success: "Lớp {courseName} đã được khôi phục thành công!"
    },
    please_resubscribe: "Vui lòng gia hạn Funclass để tiếp tục sử dụng.",
    progress: "Tiến độ",
    resubscribe: "Gia hạn",
    share: "Chia sẻ lớp học",
    shareText: "Chia sẻ liên kết để mời học sinh tham gia lớp!",
    start: "Bắt đầu lớp",
    subscription_expired: "Gói đăng ký đã hết hạn",
    title: "Bảng điều khiển lớp học",
    view: "Xem lớp học"
  },
  datetime: {
    days: {
      friday: "Thứ Sáu",
      initials: {
        friday: "T",
        monday: "H",
        saturday: "B",
        sunday: "B",
        thursday: "N",
        tuesday: "S",
        wednesday: "C"
      },
      monday: "Thứ Hai",
      saturday: "Thứ Bảy",
      short: {
        friday: "Th 6",
        monday: "Th 2",
        saturday: "Th 7",
        sunday: "CN",
        thursday: "Th 5",
        tuesday: "Th 3",
        wednesday: "Th 4"
      },
      sunday: "Chủ Nhật",
      thursday: "Thứ Năm",
      tuesday: "Thứ Ba",
      wednesday: "Thứ Tư"
    },
    time_format: "lúc {time}",
    today: "Hôm nay",
    tomorrow: "Ngày mai",
    yesterday: "Hôm qua"
  },
  homework: {
    assign: {
      assignment_info: {
        attach_files: "Đính kèm tệp",
        attachments: "Tệp đính kèm",
        choose_class: "Chọn một lớp để giao",
        class: "Lớp",
        description: "Mô tả bài tập",
        due_date: "Hạn nộp bài (giờ địa phương của bạn)",
        due_date_past: "Hạn nộp phải là một ngày trong tương lai",
        submission_required: "Yêu cầu nộp bài",
        title: "Tiêu đề",
        title_required: "Tiêu đề là bắt buộc"
      },
      confirm_leave: "Bạn có chắc chắn muốn rời khỏi trang này không? Thay đổi của bạn sẽ không được lưu.",
      create: "Giao bài",
      remove_attachment: "Xóa",
      title: "Giao bài tập",
      upload_attachments: "Tải lên tệp đính kèm"
    },
    dashboard: {
      archived: "Đã lưu trữ",
      create: "Giao bài tập",
      delete_button: "Xóa {assignment}",
      delete_confirmation: "Xác nhận xóa",
      delete_message: "Bạn có chắc chắn muốn xóa bài tập này không?",
      due: "Hạn nộp",
      filters: {
        all_classes: "Tất cả các lớp",
        all_graded: "Tất cả đã chấm điểm",
        any_status: "Bất kỳ trạng thái nào",
        archived: "Đã lưu trữ",
        assigned: "Đã giao",
        no_submission_needed: "Không cần nộp bài",
        to_be_graded: "Cần chấm điểm"
      },
      graded_on: "Đã chấm ngày",
      header: {
        class: "Lớp",
        due: "Hạn nộp",
        status: "Trạng thái",
        title: "Tiêu đề"
      },
      na: "Không áp dụng",
      no_content: {
        completed: {
          subtitle: "Các bài tập đã hoàn thành của bạn đang chờ chấm điểm sẽ hiển thị tại đây.",
          title: "Chưa có bài tập hoàn thành"
        },
        filtered: {
          subtitle: "Hãy thử thay đổi bộ lọc để tìm bài tập bạn cần.",
          title: "Không có bài tập nào khớp với bộ lọc"
        },
        general: {
          subtitle: "Nhấn vào nút “Giao bài tập” để bắt đầu!",
          title: "Chưa có bài tập nào được tạo"
        },
        graded: {
          subtitle: "Bài tập đã chấm điểm sẽ hiển thị tại đây.",
          title: "Chưa có bài tập được chấm điểm"
        },
        pending: {
          subtitle: "Quay lại sau để xem bài tập mới.",
          title: "Không có bài tập nào đang chờ"
        }
      },
      no_due_date: "Không có hạn nộp",
      notify: {
        archive_assignment_error: "Không thể lưu trữ bài tập. Vui lòng thử lại sau.",
        archive_assignment_success: "Đã lưu trữ bài tập thành công!",
        delete_assignment_error: "Không thể xóa bài tập. Vui lòng thử lại sau.",
        delete_assignment_success: "Đã xóa bài tập thành công!",
        unarchive_assignment_error: "Không thể khôi phục bài tập. Vui lòng thử lại sau.",
        unarchive_assignment_success: "Đã khôi phục bài tập thành công!"
      },
      num_submitted: "{submitted} / {total} đã nộp",
      submission_not_required: "Không yêu cầu nộp bài",
      submit: "Nộp bài",
      submitted_on: "Đã nộp vào",
      tabs: {
        completed: "Hoàn thành",
        graded: "Đã chấm điểm",
        pending: "Đang chờ"
      },
      title: "Bảng điều khiển bài tập",
      view_submission: "Xem"
    },
    details: {
      attach_files: "Đính kèm tệp",
      attachments: "Tệp đính kèm",
      delete_button: "Xóa {assignment}",
      delete_confirmation: "Xác nhận xóa",
      delete_message: "Bạn có chắc chắn muốn xóa bài tập này không?",
      description: "Mô tả",
      download_attachment: "Tải xuống",
      due: "Hạn nộp",
      edit_homework: "Chỉnh sửa bài tập",
      edit_submission: "Chỉnh sửa bài nộp",
      graded_on: "Chấm điểm vào",
      homework_details: "Chi tiết bài tập",
      homework_submission: "Nộp bài tập",
      not_submitted: "Chưa nộp",
      post_submission_success: "Nộp bài thành công!",
      remove_attachment: "Xóa",
      reward: "Phần thưởng:",
      student_submissions: "Bài nộp của học sinh",
      submission_not_required: "Không yêu cầu nộp bài",
      submit_homework: "Nộp bài",
      submitted_on: "Đã nộp vào",
      teacher_feedback: "Phản hồi của giáo viên",
      title: "Bài tập",
      upload_attachments: "Tải lên tệp đính kèm của bạn",
      view_submission: "Xem",
      your_submission: "Bài nộp của bạn"
    },
    edit: {
      assignment_info: {
        attach_files: "Đính kèm tệp",
        attachments: "Tệp đính kèm",
        choose_class: "Chọn lớp để giao bài",
        class: "Lớp",
        description: "Mô tả bài tập",
        due_date: "Hạn nộp (giờ địa phương của bạn)",
        due_date_past: "Hạn nộp phải là ngày trong tương lai",
        submission_required: "Yêu cầu nộp bài",
        title: "Tiêu đề",
        title_required: "Tiêu đề là bắt buộc"
      },
      confirm_leave: "Bạn có chắc chắn muốn rời khỏi trang này? Những thay đổi sẽ không được lưu.",
      keep_attachment: "Giữ lại",
      remove_attachment: "Xóa",
      save_changes: "Lưu thay đổi",
      title: "Chỉnh sửa bài tập",
      upload_attachments: "Tải lên tệp đính kèm của bạn"
    },
    edit_submission: {
      attach_files: "Đính kèm tệp",
      attachments: "Tệp đính kèm",
      description: "Mô tả",
      download_attachment: "Tải xuống",
      due: "Hạn nộp",
      edit_submission_success: "Chỉnh sửa bài nộp thành công!",
      homework_details: "Chi tiết bài tập",
      keep_attachment: "Giữ lại",
      last_submitted_on: "Bài nộp cuối cùng được gửi vào",
      remove_attachment: "Xóa",
      resubmit_homework: "Nộp lại",
      title: "Chỉnh sửa bài nộp",
      upload_attachments: "Tải lên tệp đính kèm của bạn",
      your_submission: "Bài nộp của bạn"
    },
    submission_details: {
      attach_files: "Đính kèm tệp",
      attachments: "Tệp đính kèm",
      description: "Nộp bài tập",
      download_attachment: "Tải xuống",
      graded_on: "Chấm điểm vào",
      remove_attachment: "Xóa",
      reward: "Phần thưởng:",
      reward_xp: "Thưởng XP",
      reward_xp_placeholder: "Nhập số XP tại đây",
      rewarding: "Đang thưởng",
      save_reward: "Lưu",
      save_reward_success: "Số XP đã được lưu thành công!",
      send_feedback: "Gửi",
      send_feedback_success: "Phản hồi đã được gửi thành công!",
      submitted_on: "Đã nộp vào",
      teacher_feedback: "Phản hồi của giáo viên",
      title: "Bài tập",
      your_feedback: "Phản hồi của bạn"
    }
  },
  inclass: {
    endLesson: "Bạn có muốn kết thúc buổi học không?"
  },
  inclassQuiz: {
    dragMe: "Kéo tôi",
    folderTitle: "Chọn thư mục",
    modeTitle: "Chọn chế độ",
    noQuizYet1: "Chưa có bài kiểm tra nào.",
    noQuizYet2: "Vui lòng tạo bài kiểm tra bên ngoài lớp học trước.",
    quizRuleDescription1: "• Với mỗi câu đúng, quái vật mất 1 mạng",
    quizRuleDescription2: "• Với mỗi câu sai, học sinh mất 1 mạng",
    quizRuleDescription3: "•⁠ Cuối bài kiểm tra, học sinh cần nhiều mạng hơn quái vật để chiến thắng!",
    quizRuleDescriptionStudent1: "• Với mỗi câu bạn trả lời đúng, quái vật mất 1 mạng",
    quizRuleDescriptionStudent2: "• Với mỗi câu sai, bạn mất 1 mạng",
    quizRuleDescriptionStudent3: "•⁠ Cuối bài kiểm tra, bạn cần nhiều mạng hơn quái vật để chiến thắng!",
    studentsJoinedCount: "học sinh đã tham gia",
    teacherPreStartQuiz: "Bạn sắp bắt đầu bài kiểm tra...",
    title: "Chọn bài kiểm tra"
  },
  lesson_status: {
    cancelled: "Đã hủy",
    completed: "Đã hoàn thành",
    completed_absence: "Đã hoàn thành (Vắng mặt)",
    no_show: "Không đến",
    ongoing: "Đang diễn ra",
    rescheduled: "Đã lên lịch lại",
    scheduled: "Đã lên lịch",
    started: "Đã bắt đầu"
  },
  meeting: {
    attention_tracker_disable: "Tắt trình theo dõi sự chú ý",
    attention_tracker_enable: "Bật trình theo dõi sự chú ý",
    button_join_quiz: "Tham gia bài kiểm tra đang hoạt động"
  },
  misc: {
    handbook: "Sổ tay"
  },
  my_calendar: {
    abort: "Hủy bỏ",
    accept_request: "Chấp nhận yêu cầu",
    all_members: "Tất cả thành viên",
    attendees: "Người tham gia",
    cancel: "Hủy",
    cancel_lesson: "Hủy buổi học",
    cancel_lesson_title: "Hủy Buổi học",
    cancellation_constraint: "Tất cả các hủy bỏ phải được thực hiện ít nhất {hours} giờ trước",
    confirm: "Xác nhận",
    confirm_approve_reschedule: "Bạn có chắc chắn muốn phê duyệt yêu cầu thay đổi lịch này không?",
    course: "Khóa học",
    date: "Ngày",
    date_time: "Ngày & Giờ",
    day: "Ngày",
    from: "từ",
    from_admin: "Từ Quản trị viên",
    join: "Tham gia",
    month: "Tháng",
    next: "Tiếp theo",
    notes: "Ghi chú",
    notify: {
      approve_reschedule_request_error: "Không thể phê duyệt yêu cầu thay đổi lịch. Vui lòng thử lại.",
      approve_reschedule_request_success: "Yêu cầu thay đổi lịch đã được phê duyệt thành công.",
      request_cancel_error: "Không thể gửi yêu cầu hủy lớp học. Vui lòng thử lại.",
      request_cancel_success: "Yêu cầu hủy lớp học đã được gửi thành công.",
      request_reschedule_error: "Không thể yêu cầu thay đổi lịch lớp học. Vui lòng thử lại.",
      request_reschedule_success: "Yêu cầu thay đổi lịch lớp học đã được gửi thành công."
    },
    previous: "Trước",
    reschedule: "Đổi lịch",
    reschedule_constraint: "Yêu cầu đổi lịch phải được thực hiện ít nhất {hours} giờ trước",
    reschedule_lesson_title: "Đổi lịch Buổi học",
    reschedule_note: "Ghi chú đổi lịch",
    reschedule_requests: "Yêu cầu đổi lịch",
    save: "Lưu",
    send_request: "Gửi yêu cầu",
    students: "Học sinh",
    subtitle: "Bạn có thể xem và quản lý tất cả các buổi học và thời gian có sẵn của mình ở đây.",
    suggest_alternative_title: "Đề xuất thời gian thay thế",
    teachers: "Giáo viên",
    title: "Lịch của tôi",
    to: "đến",
    today: "Hôm nay",
    view_lesson: "Xem Buổi học",
    week: "Tuần",
    your_requests: "Yêu cầu của bạn"
  },
  my_items: {
    change_pet_button: "Đổi thú cưng",
    confirm_button: "Xác nhận",
    feed_button: "Cho ăn",
    go_to_shop_button: "Đi tới cửa hàng",
    no_content: {
      accessories: {
        subtitle: "Bạn chưa mua gì cả.",
        title: "Không có phụ kiện nào"
      },
      food: {
        subtitle: "Bạn chưa mua gì cả.",
        title: "Không có thức ăn nào"
      },
      pets: {
        subtitle: "Hãy đến cửa hàng để mua thú cưng.",
        title: "Không có thú cưng nào"
      }
    },
    pet_reactions: {
      accessory: [
        "Cái này hoàn hảo với mình!",
        "Mình mặc cái này đẹp quá chừng!",
        "Mình nghĩ mình đã tìm ra phong cách mới rồi!",
        "Cái này hợp với mình quá!",
        "Mình thực sự rất hợp với phụ kiện này!",
        "Không thể tin được là nhìn mình đẹp vậy luôn!",
        "Mình thật sự làm chủ phong cách này rồi!",
        "Phong cách này đích thị là của mình!",
        "Nhìn mình nè, lộng lẫy chưa kìa!",
        "Mình cảm thấy thật thời trang với món này!",
        "Wow, mình trông thật lộng lẫy!",
        "Cái này được làm ra cho mình luôn!",
        "Giờ mình cảm thấy thật sang chảnh!",
        "Đây mới là thời trang!",
        "Mình trông thật bảnh bao!",
        "Dễ thương quá đáng luôn!",
        "Mình nghĩ đây là món yêu thích mới của mình!",
        "Mình cảm giác như ngôi sao vậy!",
        "Mình sinh ra là để mặc cái này!",
        "Mặc đồ thật vui quá!"
      ],
      after_eating: [
        "Ngon quá, {food_name} tuyệt vời! 😋",
        "Mình thích {food_name} lắm! ❤️",
        "Cảm ơn vì {food_name} nha! 😊",
        "{food_name}! Ngon quá trời! 😋"
      ],
      full: [
        "Mình no rồi! 😋",
        "Mình no căng rồi! 😌",
        "Mình ăn đủ rồi, cảm ơn nhé! 🙏"
      ],
      hungry: [
        "Mình đói quá! 😢",
        "Cho mình chút đồ ăn được không? 🍽️",
        "Bụng mình đang réo lên rồi! 🥺",
        "Làm ơn cho mình ăn với! 🙏"
      ]
    },
    subtitle: "Đây là vật phẩm của bạn!",
    tabs: {
      accessories: "Phụ kiện",
      food: "Thức ăn",
      pets: "Thú cưng"
    },
    take_off_button: "Tháo ra",
    title: "Vật phẩm của tôi"
  },
  notifications: {
    empty: "Không có thông báo nào",
    messages: {
      ASSIGNMENT_CREATED: "{name} đã tạo bài tập {description}",
      ASSIGNMENT_GRADED: "{name} đã chấm điểm bài tập {description}",
      ASSIGNMENT_SUBMITTED: "{name} đã nộp bài tập cho {description}",
      ENROLLMENT_STUDENT: "{name} đã đăng ký {description}",
      ENROLLMENT_STUDENT_AGENCY: "{name} đã ghi danh vào {description}",
      ENROLLMENT_TEACHER_AGENCY: "{name} đã tham gia trung tâm của bạn",
      LESSON_CANCELLED: "{name} đã hủy buổi học cho {description}",
      LESSON_CANCEL_REQUESTED: "{name} đã yêu cầu hủy buổi học cho {description}",
      LESSON_RESCHEDULED: "{name} đã dời lịch buổi học cho {description}",
      LESSON_RESCHEDULE_REQUESTED: "{name} đã yêu cầu dời lịch buổi học cho {description}",
      LESSON_REVIEWED: "{name} đã đánh giá {description} của bạn",
      STUDENT_REVIEWED: "{name} đã gửi phản hồi cho lớp {description}"
    },
    title: "Thông báo"
  },
  onboarding: {
    course: {
      browser_notice: [
        {
          acknowledgement_text: "Tôi đã đọc và hiểu.",
          body: [
            "",
            "Để có hiệu suất và khả năng tương thích tối ưu, vui lòng sử dụng một trong các trình duyệt được hỗ trợ dưới đây 🚀",
            "🔹 Máy tính để bàn / Máy tính xách tay: Chrome, Firefox hoặc Edge (phiên bản mới nhất)",
            "🔹 Di động (iOS 12.2+): Safari",
            "🔹 Di động (Android 10.0+): Chrome"
          ],
          header: [
            "⚠️ Vui lòng đọc: Trình duyệt được hỗ trợ"
          ]
        }
      ],
      egg_unhatched: "Thú cưng của bạn vẫn chưa nở. Kiếm XP từ lớp học để lên __Cấp {level}__ và nở trứng!",
      teacher: [
        {
          body: [
            "Tại Funclass, giáo viên có thể thưởng cho nỗ lực và tiến bộ của học sinh bằng XP (điểm kinh nghiệm), giống như chơi game!"
          ],
          button_text: "Tiếp theo",
          header: [],
          title: "Chào mừng đến với Funclass 🎉!"
        },
        {
          body: [
            "hiển thị quá trình học tập của họ",
            "nâng cấp thú cưng phép thuật của họ",
            "mở khóa nhiều điều bất ngờ hơn!"
          ],
          button_text: "Tiếp theo",
          header: [
            "Đừng lạm dụng XP trừ khi học sinh thể hiện nỗ lực và tiến bộ thực sự.",
            "Với XP, học sinh có thể..."
          ]
        },
        {
          body: [
            "Tham gia lớp học tích cực",
            "Kiểm tra trong lớp",
            "Hoàn thành bài tập",
            "Chuẩn bị tốt cho lớp học",
            "và các hành vi học tập tích cực khác..."
          ],
          button_text: "Tiếp theo",
          header: [],
          title: "Bạn có thể thưởng cho học sinh vì..."
        },
        "",
        {
          body: [
            "Đọc Sổ tay Funclass để biết mẹo và cách thực hành tốt nhất."
          ],
          header: []
        }
      ]
    },
    navigation: {
      finish: "Hoàn tất",
      next: "Tiếp theo",
      skip_now: "Bỏ qua"
    }
  },
  profile: {
    avatar_actions: {
      my_items: "Vật phẩm của tôi",
      pet_guide: "Hướng dẫn thú cưng",
      shop: "Cửa hàng"
    },
    avatar_messages: {
      first_xp: "Wow! Bạn đã kiếm được {lastXP} XP trong buổi học trước. Còn {xpToNextLevel} XP nữa để tôi nở. Không biết tôi sẽ trông như thế nào 🐣",
      hungry: "Tôi đói quá 🥺. Kiếm chút thức ăn từ lớp học để cho tôi ăn nhé.",
      level_up: "Wow! Bạn đã kiếm được {lastXP} XP trong buổi học trước. Còn {xpToNextLevel} XP nữa để lên cấp tiếp theo. Cố lên nhé!",
      pet_gone_generic: "Thật tiếc, thú cưng của bạn đã biến mất... 💔",
      pet_gone_named: "Thật tiếc, {petName} đã biến mất... 💔",
      pet_revive_hint_generic: "Hãy thu thập ít nhất 100 HP để hồi sinh thú cưng của bạn.",
      pet_revive_hint_named: "Hãy thu thập ít nhất 100 HP để hồi sinh {petName}.",
      pet_revived: "Cảm ơn bạn đã cố gắng tìm lại tôi! Tôi nhớ bạn lắm! Bây giờ bạn có thể cho tôi ăn rồi 🙂",
      welcome_back: "Chào {name}, chào mừng quay lại! 👋 Hôm nay chúng ta sẽ cùng học điều gì đó mới nhé! 📚✨",
      welcome_new: "Chào {name} 👋, rất vui được gặp bạn! Mình là {petName}, bạn đồng hành học tập của bạn. Kiếm XP trong lớp để giúp mình nở trứng nha! 🐣"
    },
    coin_modal: {
      earned_coins: "Wow! Bạn đã kiếm được {rewardAmount} FunCoins!",
      shop_button: "Vào cửa hàng"
    },
    feedback_modal: {
      description: "Vui lòng đánh giá trải nghiệm lớp học của bạn bên dưới",
      label: "Tại sao bạn lại đưa ra đánh giá này?",
      lesson_not_ended: "Lớp học chưa kết thúc?",
      no_rating: "Không có đánh giá",
      rating_format: "{rating}/5 sao",
      rules: {
        max: "Phản hồi không được vượt quá 300 ký tự",
        min: "Phản hồi phải dài hơn 10 ký tự",
        required: "Phản hồi là bắt buộc"
      },
      submit_button: "Gửi phản hồi",
      title: "Phản hồi lớp học"
    },
    level_up_modal: {
      submit_button: "Gửi"
    },
    pet_letter: {
      letter_title_generic: "Thư từ thú cưng của bạn",
      letter_title_named: "Thư của {petName}",
      open_button: "Mở",
      paragraph_1: "Thật tuyệt khi được làm quen với bạn và đồng hành học tập cùng bạn. Mình đã có khoảng thời gian tuyệt vời khi học với bạn. Nhưng dạo gần đây mình thấy hơi bị lãng quên 💔",
      paragraph_2: "Vì vậy, mình quyết định đi xa một thời gian để tìm một môi trường quan tâm hơn. Thu thập 200 đồng xu để mua thuốc trong cửa hàng và tìm lại tôi.",
      paragraph_3: "Mình mong sớm được gặp lại bạn!",
      received_title_generic: "Bạn đã nhận được một bức thư từ thú cưng của mình",
      received_title_named: "Bạn đã nhận được một bức thư từ {petName}",
      signature: "Thân mến,\n{petName}"
    },
    revive_pet_modal: {
      revive_button: "Hồi sinh",
      revive_message_generic: "Bạn đã thu thập đủ 100 HP 🎉\nGiờ bạn có thể hồi sinh thú cưng của mình.",
      revive_message_named: "Bạn đã thu thập đủ 100 HP 🎉\nGiờ bạn có thể hồi sinh {petName}.",
      title: "Phần thưởng"
    },
    title: "Ngôi nhà của tôi",
    your_classes: "Lớp học của bạn"
  },
  quiz: {
    create: "Tạo bài kiểm tra",
    create_description: "Mô tả bài kiểm tra",
    create_name: "Tên bài kiểm tra",
    delete: "xóa",
    delete_confirmation: "Xác nhận xóa",
    delete_message: "Bạn có chắc chắn muốn xóa bài kiểm tra này không?",
    edit: {
      add_alt_answer: "Thêm đáp án thay thế",
      add_answer: "Thêm đáp án",
      add_question: "Thêm câu hỏi",
      delete_message: "Bạn có chắc chắn muốn xóa câu hỏi này không?",
      delete_question: "Xóa câu hỏi",
      save_question: "Lưu câu hỏi",
      title: "Chỉnh sửa bài kiểm tra"
    },
    edit_questions: "Chỉnh sửa câu hỏi",
    folder: {
      create: "Tạo thư mục",
      create_name: "Tên thư mục",
      delete: "Xóa thư mục",
      delete_confirmation: "Xác nhận xóa",
      delete_message: "Bạn có chắc chắn muốn xóa thư mục này không? Tất cả bài kiểm tra bên trong cũng sẽ bị xóa.",
      edit: "Chỉnh sửa thư mục",
      name_limit: "Không được vượt quá 50 ký tự",
      name_not_empty: "Tên thư mục không được để trống",
      save: "Lưu thư mục",
      title: "Bảng điều khiển bài kiểm tra"
    },
    name_limit: "Không được vượt quá 50 ký tự",
    name_not_empty: "Tên bài kiểm tra không được để trống",
    save: "Lưu bài kiểm tra",
    title: "Bảng điều khiển bài kiểm tra"
  },
  recording: {
    delete_confirmation: "Bạn có chắc chắn muốn xóa bản ghi này không?"
  },
  scheduling: {
    edit: {
      error: "Đã xảy ra lỗi khi cập nhật sự kiện",
      options: {
        current: "Buổi học này",
        future: "Buổi học này và các buổi sau",
        title_delete: "Chọn sự kiện để xóa",
        title_edit: "Chọn sự kiện để áp dụng thay đổi"
      },
      title: "Chỉnh sửa buổi học đã lên lịch"
    },
    end_date: "Ngày kết thúc",
    lesson_time: "Giờ học",
    lesson_time_info: "Chọn giờ địa phương của bạn. Giờ sẽ được điều chỉnh theo múi giờ của học sinh.",
    recurrence: {
      biweekly: "Mỗi 2 tuần",
      custom: "Tùy chỉnh",
      daily: "Hàng ngày",
      label: "Lặp lại",
      none: "Không",
      occurs_on: "Diễn ra vào",
      repeat_every: "Lặp lại mỗi",
      time_unit_day: "ngày | ngày",
      time_unit_week: "tuần | tuần",
      weekly: "Hàng tuần"
    },
    reminder: {
      hours_before: "{n} giờ trước",
      label: "Nhắc nhở cho học sinh"
    },
    start_date: "Ngày bắt đầu"
  },
  shop: {
    buy_now_button: "Mua ngay",
    buy_pet_button: "Mua thú cưng",
    cancel_button: "Hủy",
    confirm_button: "Xác nhận",
    level_constraint: "Đạt cấp {level} để mở khóa món đồ này",
    no_content: {
      accessories: {
        subtitle: "Quay lại sau để xem thêm món đồ.",
        title: "Không có phụ kiện nào"
      },
      food: {
        subtitle: "Quay lại sau để xem thêm món đồ.",
        title: "Không có thức ăn nào"
      },
      pets: {
        subtitle: "Quay lại sau để xem thêm thú cưng.",
        title: "Không có thú cưng nào"
      },
      wallpapers: {
        subtitle: "Quay lại sau để xem thêm hình nền.",
        title: "Không có hình nền nào"
      }
    },
    notify: {
      pet_name_required: "Vui lòng nhập tên thú cưng"
    },
    pet_name: "Tên thú cưng",
    pet_name_prompt: "Hãy đặt tên cho thú cưng của bạn!",
    subtitle: "Bạn có thể mua đồ cho thú cưng của mình tại đây!",
    title: "Cửa hàng"
  },
  sidebar: {
    actions: {
      account_settings: "Cài đặt tài khoản",
      logout: "Đăng xuất"
    },
    activities: {
      homework: "Bài tập",
      quiz: "Bài kiểm tra",
      short_title: "Hoạt động",
      title: "Hoạt động"
    },
    agency_name_placeholder: "Cơ sở của bạn",
    courses: {
      calendar: "Lịch",
      courses: "Khóa học",
      history: "Lịch sử",
      short_title: "Khóa học",
      title: "Khóa học"
    },
    general: {
      home: "Trang chủ",
      short_title: "Chung",
      students: "Học sinh",
      teachers: "Giáo viên",
      title: "Chung"
    }
  },
  understandingCheck: {
    start: "Bạn sắp bắt đầu kiểm tra hiểu bài",
    student: "Hiện tại bạn cảm thấy thế nào?",
    studentButtonNo1: "Hmm 🤔️",
    studentButtonNo2: "Hơi bối rối.",
    studentButtonYes1: "Tốt! 😄",
    studentButtonYes2: "Tôi đã hiểu.",
    teacher: "Cảm xúc của học sinh hiện tại"
  },
  upload: {
    agency_logo_upload: "Tải lên logo của cơ sở",
    drag_and_drop: "hoặc kéo và thả vào đây",
    photo_upload: "Tải ảnh lên",
    pick_file: "Chọn tệp",
    square_image: "Khuyến nghị dùng ảnh vuông",
    upload: "Tải lên",
    upload_file: "Tải tệp lên",
    upload_file_type: "Chỉ chấp nhận định dạng {formats}"
  },
  viewClass: {
    absence: "Vắng mặt",
    addMore: "Thêm học sinh",
    addStudent: "Mời học sinh",
    addStudents: "Thêm học sinh",
    attendance: "Điểm danh",
    date: "Ngày",
    download_recording: "Tải bản ghi xuống",
    email: "Địa chỉ email",
    enterEmail: "Nhập email học sinh tại đây",
    feedback_button: "Phản hồi",
    invite: "Mời",
    lesson: "Bài học",
    notEmpty: "Trường này không được để trống",
    notValid: "Email không hợp lệ",
    recording_button: "Bản ghi",
    student_name: "Tên học sinh",
    tabs: {
      course_material: "Slide trong lớp",
      lesson_history: "Lịch sử bài học",
      student_list: "Danh sách học sinh"
    },
    xps_earned: "Điểm XP đã nhận"
  }
};
